__turbopack_context__.v({
  "contained": "ButtonVariants-module__HwDIEG__contained",
  "darkMode": "ButtonVariants-module__HwDIEG__darkMode",
  "error": "ButtonVariants-module__HwDIEG__error",
  "icon": "ButtonVariants-module__HwDIEG__icon",
  "link": "ButtonVariants-module__HwDIEG__link",
  "loading": "ButtonVariants-module__HwDIEG__loading",
  "mint": "ButtonVariants-module__HwDIEG__mint",
  "neutral": "ButtonVariants-module__HwDIEG__neutral",
  "outlined": "ButtonVariants-module__HwDIEG__outlined",
  "primary": "ButtonVariants-module__HwDIEG__primary",
  "secondary": "ButtonVariants-module__HwDIEG__secondary",
  "tertiary": "ButtonVariants-module__HwDIEG__tertiary",
  "text": "ButtonVariants-module__HwDIEG__text",
});
